module.exports = __webpack_public_path__ + "img/gh-30282-2-74.prt.566c4305.jpg";